import React from 'react';
import { Link } from 'react-router-dom';
import './NRFSection.css';

const NRFSection = () => {
  return (
    <section className="nrf-section fade-in" id="evenements">
      <div className="nrf-card">
        <img
          src="/images/nrf-apac.jpg"
          alt="NRF APAC Logo"
          className="nrf-logo"
        />
        <p className="nrf-text-gold">
          Laetitia et Adrien seront à NRF 2026 Asia Pacific à Singapour, l'un des grands rendez-vous du retail et de l'innovation en Asie-Pacifique, qui se tiendra du 3 au 5 juin 2026.
        </p>
        <p className="nrf-text-white">
          Sur place, ils capteront les tendances clés, les innovations marquantes et les signaux faibles qui façonnent le commerce dans la région. Avec The Recap, ils proposeront une lecture claire et synthétique de ce qu'il faut vraiment retenir : dynamiques de marché, visions d'experts et insights terrain.
        </p>
        <p className="nrf-text-white">
          Un live LinkedIn aura lieu le 4 juin pour décrypter à chaud les enseignements de l'événement, suivi d'un dîner à Paris le 11 juin pour prolonger les échanges avec la communauté.
        </p>
        <p className="nrf-text-white">
          Une manière simple et concrète d'accéder au meilleur de la NRF APAC, de Singapour à Paris.
        </p>
        <Link to="/inscription" className="button button-gold nrf-button">
          S'inscrire au prochain live
        </Link>
      </div>
    </section>
  );
};

export default NRFSection;
